import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { push } from 'redux-router';
import { ReduxRouterAction } from 'redux-router/lib/actionCreators';
import { fetchUserInfoDeferred, productInfoDeferred } from '../actions/Actions';
import {
  IAddress,
  IProductInfo,
  IReferer,
  IState,
  IUserInfo
} from '../CustomTypes';
import { createB64data } from '../fastflowUtils';
import LegalAge from '../gdpr/LegalAge';
import { svgAddress } from '../icons';
import { Button } from '../input-components/InputComponents';
import './UserInfo.scss';
import { sccPulseTrackPageView } from '../PulseUtils';

export interface IDispatchProps {
  push: (...args: Array<object | string>) => ReduxRouterAction;
}

export interface IStateProps {
  __rct?: string;
  productInfo: IProductInfo;
  userInfo: IUserInfo;
  address: IAddress;
  referer: IReferer;
  paymentMethodId: string;
  purchasedSubscriptionId: number;
}

export interface IProps extends IDispatchProps, IStateProps {}

export class UserInfo extends React.Component<IProps> {
  constructor(props: IProps) {
    super(props);
    this.edit = this.edit.bind(this);
    this.nextStep = this.nextStep.bind(this);
  }

  public componentDidMount() {
    const eventName = 'User info';
    productInfoDeferred.promise.then(product => {
      fetchUserInfoDeferred.promise
        .then(user => {
          sccPulseTrackPageView(product, user, eventName);
        })
        .catch(() => {
          sccPulseTrackPageView(product, this.props.userInfo, eventName);
        });
    });
  }

  public render() {
    const { userInfo, address, paymentMethodId } = this.props;
    return (
      <div className="container userinfo">
        <h1>{svgAddress()}</h1>
        <h1>Din leveringsadresse</h1>
        <h4>
          Du har en tidligere registert adresse hos oss. Ønsker du å benytte
          denne fortsatt?
        </h4>
        <div className="mask greybox">
          <table className="infotable">
            <tbody>
              <tr>
                <td>
                  <span className="glyphicon glyphicon-user" />
                </td>
                <td>
                  {userInfo.firstName} {userInfo.lastName}
                </td>
              </tr>
              <tr>
                <td>
                  <span className="glyphicon glyphicon-earphone" />
                </td>
                <td>{this.props.userInfo.phoneNumber}</td>
              </tr>
              <tr>
                {/* <td className="icon">{svgHouse(18)}</td> */}
                <td>
                  <span className="glyphicon glyphicon-map-marker" />
                </td>
                <td className="address">
                  {address.streetAddress} {address.houseNumber}{' '}
                  {address.entrance}, {address.zipCode} {address.city}
                </td>
              </tr>
            </tbody>
          </table>
          <hr />
          <div className="change">
            <a onClick={this.edit}>
              <span className="glyphicon glyphicon-pencil" /> Endre
            </a>
          </div>
        </div>
        <Button onClick={this.nextStep}>
          {(paymentMethodId && 'Fullfør kjøp') || 'Til betaling'}
        </Button>

        <LegalAge />
      </div>
    );
  }

  private edit() {
    const { spidId, sig } = this.props.userInfo;
    const { redirectUri, referer } = this.props.referer;
    let rctParam = '';
    if (this.props.__rct) {
      rctParam += `&__rct=${this.props.__rct}`;
    }
    const redirectParams =
      redirectUri || referer
        ? `&redirect_uri=${encodeURIComponent(
            redirectUri
          )}&referer=${encodeURIComponent(referer)}${rctParam}`
        : '';
    const { paymentMethodId, purchasedSubscriptionId } = this.props;
    const paymentMethodAndSubscriptionParams =
      paymentMethodId && purchasedSubscriptionId
        ? `&purchasedSubscriptionId=${purchasedSubscriptionId}&paymentMethodId=${paymentMethodId}`
        : '';
    this.props.push(
      `/products/${
        this.props.productInfo.productId
      }/address?spidId=${spidId}&sig=${sig}${redirectParams}${paymentMethodAndSubscriptionParams}${rctParam}`
    );
  }

  private nextStep() {
    const { productId } = this.props.productInfo;
    const { spidId, sig, phoneNumber, email } = this.props.userInfo;
    const b64data = createB64data(
      this.props.address,
      this.props.referer,
      phoneNumber,
      false,
      email
    );
    let rctParam = '';
    if (this.props.__rct) {
      rctParam += `&__rct=${this.props.__rct}`;
    }
    const { paymentMethodId, purchasedSubscriptionId } = this.props;
    if (paymentMethodId && purchasedSubscriptionId) {
      const params = `paymentMethodId=${paymentMethodId}&purchasedSubscriptionId=${purchasedSubscriptionId}&spidId=${spidId}&sig=${sig}&b64data=${encodeURIComponent(
        b64data
      )}${rctParam}`;
      this.props.push(`/products/${productId}/placeorder?${params}`);
    } else {
      this.props.push(
        `/products/${productId}/selectpaymentmethod?spidId=${spidId}&sig=${sig}&b64data=${encodeURIComponent(
          b64data
        )}${rctParam}`
      );
    }
  }
}

export default connect(
  (state: IState) =>
    ({
      _rct: state.router.location.query.__rct,
      address: state.address,
      paymentMethodId: state.router.location.query.paymentMethodId,
      productInfo: state.productInfo,
      purchasedSubscriptionId:
        state.router.location.query.purchasedSubscriptionId,
      referer: state.referer,
      userInfo: state.userInfo
    } as IStateProps),
  dispatch => bindActionCreators({ push }, dispatch) as IDispatchProps
)(UserInfo);



// WEBPACK FOOTER //
// ./src/page-components/UserInfo.tsx